import { render, staticRenderFns } from "./PDPStickyCTAPricing.vue?vue&type=template&id=18f76238&scoped=true"
import script from "./PDPStickyCTAPricing.vue?vue&type=script&lang=js"
export * from "./PDPStickyCTAPricing.vue?vue&type=script&lang=js"
import style0 from "./PDPStickyCTAPricing.vue?vue&type=style&index=0&id=18f76238&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f76238",
  null
  
)

export default component.exports